import React from 'react'
import graphql from 'babel-plugin-relay/macro'
import { fetchQuery } from 'config/amber-relay'
import Select from 'components/v2/Select'

export default function UserSelect(props) {
  const { onlyEnable, ...rest } = props
  const fetch = async where => {
    let finalWhere = where

    if (onlyEnable) {
      finalWhere = {
        and: [
          where,
          { isDisabled: { eq: 'false' } }
        ]
      }
    }

    const { users } = await fetchQuery(
      graphql`
        query UserSelectQuery($where: UserWhere) {
          users(where: $where, first: 10, orderBy: [name], order: ASC) {
            edges {
              node {
                id
                name
                locationId
              }
            }
          }
        }
      `,
      { where: finalWhere }
    )
    return users.edges.map(({ node }) => ({
      key: node.id,
      value: node.id,
      text: node.name,

    }))
  }

  return (
    <Select
      {...rest}
      getByValue={value => {
        const conditions = [{ id: { eq: value } }]
        return fetch({ and: conditions })
      }}
      loadOptions={searchQuery => {
        const conditions = []
        if (searchQuery !== undefined) {
          conditions.push({ name: { iLike: `${searchQuery}%` } })
        }
        return fetch({ and: conditions })
      }}
    />
  )
}

UserSelect.defaultProps = {
  label: 'Usuario',
  placeholder: 'Usuario',
  loadOnMount: true,
  onlyEnable: true
}
